import{jsx as t}from"react/jsx-runtime";import i from"styled-components";import{withVDSManager as r}from"@vds-core/utilities";import o from"./IconListItem.js";const n=i.ul.withConfig({displayName:"List",componentId:"VDS__sc-1ts0cdj-0"})`
  margin: 0px;
  padding: 0px;
  li:last-of-type {
    margin-bottom: 0;
  }
`;var s=r((function({data:i,surface:r="light",viewport:s,spacing:a="standard"}){return t(n,{children:i.map((function(i,n){return t(o,Object.assign({surface:r,viewport:s,listSpacing:a},i),n)}))})}));export{s as default};
